<div class="item-inner">
	<div class="item-top">
		<img [userImage]="user.id">
		<div>
			<span>{{ user.team }}</span><br />
			{{ user.name }}
		</div>
	</div>
	<div class="item-content col-12">
		{{ 'blocklist-user.qualification-call-count' | translate }}
		<div class="call-count">{{ user.callCount }}</div>
		{{ 'blocklist-user.onboarding-flow-value' | translate }}
		<div class="total-value">{{ user.totalValue | currency }}</div>
	</div>
</div>
